
import React from 'react';
import Button from '../../Button';
import FontAwesomeIcon from '../../Icon';
import { SortIcon } from './SortIcon';
import TextEditor from '../../Editor/Editor';

export const AddChecklistComponent = ({ checklists, data, onAddFaq, onSetFaq, onSetEditFaq, handleChecklistDelete, onEditorFaqChange, onSortingChecklist, onClearFormData }) => {
    let validation = data.checklistTitle && data.checklistTitle.trim();
    let isIdsAvailable = checklists && checklists.length > 0 ? checklists.filter(cl => cl.id) : []

    return (
        <div class="input_box">
            {checklists && checklists.length > 0 ?
                checklists.filter(q => !q.isdeleted).
                    map((checklist, index) => {
                        return (
                            <>

                                <div className='homeOwnercard mt-15 mb-15'
                                    draggable={isIdsAvailable && isIdsAvailable.length === 0 || checklist.id ? true : false}
                                    onDragStart={() => onSortingChecklist(checklist, index, 'start')}
                                    onDrop={() => onSortingChecklist(checklist, index, 'drop')}
                                    onDragOver={(e) => {
                                        e.stopPropagation(); e.preventDefault();
                                    }}
                                >
                                    {isIdsAvailable && isIdsAvailable.length === 0 || checklist.id ? <SortIcon /> : null}
                                    <div className='deleteIcon' style={{ textAlign: 'right', cursor: 'pointer', float: 'right' }}
                                        onClick={() => window.confirm(`Are you sure you want to delete Checklist?`) && handleChecklistDelete(checklist)}
                                    >
                                        <FontAwesomeIcon
                                            glyph="trash"
                                            weight="light"
                                            size="small"
                                        />
                                        Delete Checklist
                            </div>
                                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                                        <div class='mt-10 tabsInputLable'>Title:<span className='input__required' /> </div>
                                        <div class='tabsInputForm'>
                                            <input class="form-control" type="text" placeholder="Title" aria-label="default input example"
                                                value={checklist.title}
                                                onChange={e => onSetEditFaq(e.target.value, 'title', index)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                                        <div class='mt-10 tabsInputLable'>Description:</div>
                                        <div class='inputFormoffer w-100 pr-10'>
                                            <div class style={{ border: '0.1rem solid rgba(83, 83, 83, 0.25)', borderRadius: '5px', padding: '0px', marginBottom: 25 }} className="input__control">
                                                <TextEditor
                                                    editorState={checklist.subTitle}
                                                    onEditorStateChange={editorState => onSetEditFaq(editorState, 'subTitle', index)}
                                                    placeholder={'Description'}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </>
                        )
                    }) : null}
            <>
                <div className='homeOwnercard mt-15 mb-15'>
                    {data.checklistTitle ?
                        <a onClick={() => onClearFormData('checklist')} className='clearLink deleteIcon' style={{ textAlign: 'right', cursor: 'pointer', float: 'right' }}> Clear </a> : null}
                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                        <div class='mt-10 tabsInputLable'>Title:<span className='input__required' /> </div>
                        <div class='tabsInputForm'>
                            <input class="form-control" type="text" placeholder="Title" aria-label="default input example"
                                value={data.checklistTitle}
                                onChange={e => onSetFaq(e.target.value, 'checklistTitle')}
                                required
                            />
                        </div>
                    </div>
                    <div className="input__errors">
                        {data.checklistValidation && <div className="input__error">{data.checklistValidation}</div>}
                    </div>
                    <div class="homeOwnerinput_section homeOwnerinputContainer w-100">
                        <div class='mt-10 tabsInputLable'>Description:</div>
                        <div class='inputFormoffer w-100 pr-10'>
                            <div class style={{ border: '0.1rem solid rgba(83, 83, 83, 0.25)', borderRadius: '5px', padding: '0px', marginBottom: 25 }} className="input__control">
                                <TextEditor
                                    editorState={data.checklistSubtitle}
                                    onEditorStateChange={onEditorFaqChange}
                                    placeholder={'Description'}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </>
            <Button
                color="teal"
                size="small"
                label="+ Add New Checklist"
                disabled={!validation}
                onClick={onAddFaq}
            />
        </div>
    )
}